import axios from "axios";
export default {
    inject: ["openShowModalLoading", "closeShowModalLoading"],
    data() {
        return {
            pathResourcePrescrizioniModalitaSomministrazione: "/rsapazienteprescrizionimodalitasomministrazione",
            prescrizioneModalitaSomministrazioneOptions: []
        };
    },
    methods: {
        rsaPazientePrescrizioniLoad() {
            let link = process.env.VUE_APP_PATH_API + this.pathResourcePrescrizioniModalitaSomministrazione;
            this.prescrizioneModalitaSomministrazioneOptions = [];
            axios.get(link)
                .then((response) => {
                    this.prescrizioneModalitaSomministrazioneOptions = response.data.data.list.filter(e => e.nome != 'NON DEFINITO');
                    //this.magazzinoArticoliLottiRecordNumbers = response.data.data.recordsNumber;
                })
                .catch((error) => {
                    this.$bvToast.toast("Errore nel caricamento dati: " + error.message, {
                        title: "",
                        variant: "danger",
                        solid: true,
                    });
                });
        },
    },
};
